<template>
  <button ref="btn"  @click="getAccess">
    <img :src="img_src" alt="Connect with Google" loading="eager"> 
    {{ btn_text }}
  </button>
</template>

<script>
import  { mapGetters, mapMutations, mapActions } from "vuex";
import { imagePath, sendReportDataLayer, objectLength } from "@/utils";
import { generateGoogleLink } from "@/consts/google-oauth";

export default {
  name: "GoogleConnectionBtn",
  props: {
    btnText: {
      type: [ Boolean, String ],
      default: false,
    }
  },
  computed: {
    ...mapGetters(['get_email_cta', 'get_response']),

    btn_text() {
      const is_string = this.btnText.length > 0;

      if ( is_string ) return this.btnText;
      return this.btnText
        ? 'Connect a different account'
        : 'Connect with Google';

    },
    img_src: () => imagePath('icons/google.svg'),
  },
  methods: {
    ...mapMutations(['SET_LOADING']),
    ...mapActions(['GET_GOOGLE_ADWORDS']),


    getAccess() {
      const win = window.open(
        generateGoogleLink(this.get_email_cta)
      );
      const interval = setInterval(() => {
        if (!win.closed) return;
        window.clearInterval(interval);
        this.getUserData()
      }, 200);
    },
    
    async getUserData() {
      const { error } = await this.GET_GOOGLE_ADWORDS();
      const res = this.get_response;
      const msg = res.msg.toLowerCase();
      const success = !!objectLength(res.ids ?? {});
      const eligible = !!objectLength(res.ineligibleIds ?? {});
      const protectedIds = !!objectLength(res.protectedIds ?? {})
      this.sendEvent({ success, eligible, protectedIds, msg });

      // handle emits
      if(error) return this.$emit('failure', msg);
      this.$emit('success');
    },

    sendEvent({success, eligible, protectedIds, msg}) {
      const customer = msg === "account already protected by clickcease" || protectedIds;

      sendReportDataLayer({
        report_step: 2,
        report_step_name: 'Connect',
        success: success ? "Yes" : "No",
        eligible: eligible ? "Yes" : "No",
        customer: customer ? "Yes" : "No",
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
button {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  background: $white;
  padding: 24px 32px;
  border-radius: 50px;
  box-shadow: 0px 0px 30px #B7442721;
  border: none;
}
img {
  margin-right: 12px;
}
</style>